import { useEffect } from "react";
import { ZAMMAD_FORM } from "../config";
import { observeZammadModals } from "./zammadFormActions";

const useZammadForm = (email: string, enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const observer = observeZammadModals(document.body);

    const loadScript = (src: string, id: string, callback?: () => void) => {
      if (document.getElementById(id)) return;
      const script = document.createElement('script');
      script.src = src;
      script.id = id;
      script.async = true;
      script.onload = callback || null;
      document.body.appendChild(script);
    };

    loadScript('https://code.jquery.com/jquery-3.6.0.min.js', 'jquery', () => {
      loadScript(ZAMMAD_FORM, 'zammad_form_script', () => {
        (window as any).$(() => {
          (window as any).$('.show-zammad-form').ZammadForm({
            messageTitle: 'Support-Request',
            messageSubmit: 'Send',
            messageThankYou: 'Thanks for your inquiry (#%s). We will contact you soon.',
            showTitle: true,
            modal: true,
            lang: 'en',
            attachmentSupport: true,
            attributes: [
              {
                display: 'Name',
                name: 'name',
                tag: 'input',
                type: 'text',
                placeholder: 'Your Name',
                defaultValue: '',
              },
              {
                display: 'Email',
                name: 'email',
                tag: 'input',
                type: 'email',
                required: true,
                placeholder: 'Your Email',
                defaultValue: email,
              },
            ]
          });
        });
      });
    });
    return () => {
      observer.disconnect();
      const jqueryScript = document.getElementById('jquery');
      const zammadScript = document.getElementById('zammad_form_script');
      if (jqueryScript) jqueryScript.remove();
      if (zammadScript) zammadScript.remove();
    };
  }, [email, enabled]);
};

export default useZammadForm;
